<template>
  <div class="home">
    <el-button
      type="text"
      class="back-button"
      icon="el-icon-arrow-left"
      @click="$router.replace({ name: 'Home' })"
    ></el-button>
    <img class="bg-banner" :src="activity.coverImage" />
    <div class="index-container">
      <div class="box-rect">
        <div class="index-title">
          <span>{{ activity.name }}</span>
        </div>
        <div>
          <span>活动状态：</span>
          <span class="status" :class="activity.status">{{
            statusLable[activity.status] || "未开始"
          }}</span>
        </div>
      </div>
      <div class="box-rect">
        <div>
          <!-- <div class="line-height-50">
            <span icon="time" color="black" :size="15"></span>
            <span>售票开始时间：{{ activity.saleStartTime }}</span>
          </div>
          <div class="line-height-50">
            <span icon="time" color="black" :size="15"></span>
            <span>售票截止时间：{{ activity.saleEndTime }}</span>
          </div> -->
          <div class="line-height-50">
            <span icon="note" color="black" :size="15"></span>
            <span>主办公司：{{ activity.companyName }}</span>
          </div>
        </div>
      </div>

      <div class="box-rect">
        <div>
          门票种类：
          <el-radio-group size="small" v-model="selectedTicketCategory">
            <el-radio-button
              v-for="option in ticketCategoryList"
              :key="option.name"
              :label="option.name"
              >{{ option.name }}票 ¥{{ option.price }}</el-radio-button
            >
          </el-radio-group>
        </div>
      </div>

      <div class="box-rect">
        <div>购票须知：{{ activity.description }}</div>
      </div>

      <!-- <div class="box-rect">
    <div>活动开始时间：{{activity.startTime}} </div>
    <div>活动结束时间：{{activity.endTime}}</div>
    <div>举办地点：{{activity.address}}</div>
  </div> -->

      <div class="submit-button" v-if="loaded">
        <div @click="applyHandle" v-if="!isOver && !isStock">我要购票</div>
        <div :class="{ disabled: isOver || isStock }" v-else>
          {{ isOver ? "已结束售票" : "已售罄" }}
        </div>
      </div>
      <div
        class="rich-html-wrap"
        style="padding-bottom: 50px;"
        v-html="richContent"
      >
        <!-- <img
          v-for="(item, i) in contentImgs"
          :key="i"
          mode="widthFix"
          style="width: 100%;"
          :src="item"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { getTicketDetail, getDiscounts } from "@/api/index.js";
import store from "@/store/index.js";

export default {
  name: "Activity",
  data() {
    return {
      ticketCategoryList: [],
      selectedTicketCategory: "",
      activity: {},
      statusLable: {
        NOT_STARTED: "未开始",
        IN_PROGRESS: "进行中",
        COMPLETED: "已结束"
      },
      contentImgs: [],
      richContent: "",
      discounts: [],
      discountCondition: 0,
      discount: 10,
      isOver: false,
      isStock: false,
      loaded: false
    };
  },
  created() {
    this.getTicketDetail();
  },
  methods: {
    getTicketDetail() {
      getTicketDetail(this.$route.params.activityId).then(res => {
        this.loaded = true;
        this.activity = res;
        store.commit("normal/SET_ACTIVITY", this.activity);
        // this.contentImgs = res.content.split(",");
        this.richContent = decodeURIComponent(res.content || "");

        this.isStock = this.activity.stock >>> 0 === 0;

        this.isOver =
          new Date(this.activity.saleEndTime.replace(/-/g, "/")).getTime() <
          Date.now();

        this.getDiscounts();
        this.getTsRoomLayoutList();
      });
    },
    getDiscounts() {
      getDiscounts(this.activity.id).then(res => {
        this.discounts = res;
        if (res.length) {
          this.discountCondition = res[0].condition;
          this.discount = res[0].discount;
        }
      });
    },
    getTsRoomLayoutList() {
      this.ticketCategoryList = [
        {
          name: "VIP",
          price: window.config.vipPriceLabel
        },
        {
          name: "标准",
          price: window.config.normalPriceLabel
        }
      ];
    },
    applyHandle() {
      if (!this.selectedTicketCategory) {
        this.$message.info("请选择门票种类！");
        return;
      }
      const currentDiscount =
        this.discounts.find(d => {
          if (this.selectedTicketCategory === "VIP") {
            return d.area && d.area.indexOf("VIP") !== -1;
          } else {
            return d.area && d.area.indexOf("VIP") === -1;
          }
        }) || {};

      let query = {
        // price: this.activity.price || 0,
        // id: this.activity.id || "",
        // stock: this.activity.stock || 0,
        discountCondition: currentDiscount.condition || 0,
        discount: currentDiscount.discount || 10,
        activityId: this.activity.id,
        ticketTips: this.activity.metadata.ticketTips,
        ticketCategory: this.selectedTicketCategory
        // roomId: this.activity.roomId,
        // name: this.activity.name,
        // address: this.activity.address,
        // dateTime: `${this.activity.metadata.signInStartTime}-${this.activity.metadata.signInEndTime}`
      };

      // window.wx.miniProgram.navigateTo({
      //   url: `../buyTicket/buyTicket?${Object.keys(params)
      //     .map(v => `${v}=${params[v]}`)
      //     .join("&")}`
      // });
      this.$router.push({
        name: "BuyTicket",
        query: query
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.rich-html-wrap {
  /deep/ img {
    max-width: 100%!important;
    height: auto!important;
  }
}
.bg-banner {
  width: 100%;
  z-index: -1;
}

.home {
  background-color: #f8f9ff;
}

.index-container {
  height 100%
  text-align: left;
  margin-top: -10px;
  padding-bottom: 65px;
}

.index-title {
  font-size: 20px;
  font-family: "微软雅黑";
  font-weight: bold;
  margin-top: -5px;
  margin-bottom: 8px;
  color: #111111;
}

.box-rect {
  background-color: #ffffff;
  margin: 10px 0;
  padding: 10px 15px;
  color: #454545;
  font-size: 13px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .04);
}

.box-rect .status {
  display: inline-block;
  color: #ffffff;
  font-size: 11px;
  padding: 0 8px;
  height: 18px;
  line-height 18px;
  border-radius: 9px;
  background-color: #aaaaaa;
  &.NOT_STARTED {
    background-color: #d0011b;
  }
  &.IN_PROGRESS {
    background-color: #57b837;
  }
  &.COMPLETED {
    background-color: #aaaaaa;
  }
}

.line-height-50 .weui-icon {
  margin-right: 8px;
  margin-top: -3px;
}

.box-rect .line-height-50 {
  padding-top: 10px;
}

.box-rect .item-button {
  background-color: #fff2d8;
  border: 1px solid #d8b32f;
  color: #dead4e;
  font-size: 15px;
  display: inline-block;

  height: 25px;
  padding: 0 8px;
  border-radius: 13px;
  margin: 8px 0;
}

.box-rect .title {
  font-size: 15px;
  font-weight: bold;
  line-height: 18px;
  font-family: "微软雅黑";
  color: #111111;
  margin-bottom: 5px;
}

.price {
  font-weight: bold;
  color: green;
}

.submit-button div.disabled {
  background-image: linear-gradient(90deg, #cecece, #e3e3e3);
  box-shadow: none;
}
</style>
